import { Outlet } from "react-router-dom";
import WarehouseForm from "./WarehouseForm";
import WarehouseList from "./WarehouseList";

export const adminWarehouseRoutes = [
  {
    path: "warehouses",
    element: Outlet,
    children: [
      {
        path: "",
        element: WarehouseList,
      },
      {
        path: "add",
        element: WarehouseForm,
      },
      {
        path: "edit/:id",
        element: WarehouseForm,
      },
    ],
  },
];
